import { pageDto } from "./pagedto";
import { AdministrativeFeeCatalogDto } from './administrativefeecatalogdto';

export class AdministrativeFeeCatalogResponse {

    listAdministrativeFeeCatalogDto: AdministrativeFeeCatalogDto[] = [];

    pageDto: pageDto = new pageDto({});

}